import { useTranslation } from '@framework/i18n';

export interface IErrorTextTranslation {
  title: string;
  message: string;
}

export const getDefaultErrorTextFromStatus = (
  t: ReturnType<typeof useTranslation>['t'],
  status?: number,
): IErrorTextTranslation => {
  switch (status) {
    case 403:
      return {
        title: t(
          'errors-default.403.titolo.non-autorizzato',
          '403 Non Autorizzato',
        ),
        message: t(
          'errors-default.403.messaggio.non-autorizzato',
          'Non si dispone dei permessi per visualizzare la pagina richiesta.',
        ),
      };
    case 404:
      return {
        title: t(
          'errors-default.404.titolo.non-trovato',
          '404 Non Trovato',
        ),
        message: t(
          'errors-default.404.messaggio.non-trovata',
          'Pagina Non Trovata.',
        ),
      };
    case 500:
      return {
        title: t(
          'errors-default.500.titolo.errore-interno-server',
          '500 Errore Interno Server',
        ),
        message: t(
          'errors-default.500.messaggio.errore-interno-server',
          "Si è verificato un errore non previsto del server. Si prega di riprovare o contattare l'assistenza.",
        ),
      };
    default:
      return {
        title: t(
          'errors-default.generico.titolo.errore-network',
          'Errore Network',
        ),
        message: t(
          'errors-default.generico.messaggio.errore-network',
          'Sì è verificato un errore nella richiesta.',
        ),
      };
  }
};
